import React from "react";
import { css, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
    showSubMenu: boolean,
};

const BurgerNavSubContainer: React.FC<Props> = ({ children, showSubMenu }) => {
    const theme = useTheme();

    const style = css`
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: start;
        padding: 20px 55px;
        width: 50%;
        background-color: ${showSubMenu ? theme.colours.white : theme.colours.curiousBlue};
        box-shadow: ${theme.borderAndShadow.boxInsetTopShadow1};

        ${theme.breakpoints.down("md")} {
            display: none;
        }
    `;

    return (
        <div css={style}>
            {children}
        </div>
    );
};

export default BurgerNavSubContainer;